import React from 'react';
import ReactForms from 'react-forms';
import email from 'email-validation';

import Field from 'ofs/forms/components/better-field';
import {gettext} from 'ofs/i18n';

const {Scalar} = ReactForms.schema;

const MESSAGES = {
  EMAIL_ERROR: gettext('Must be a valid email address'),
};


function emailValidator(schema, v) {
  if (!email.valid(v)) {
    return new Error(MESSAGES.EMAIL_ERROR);
  }
}

export default function EmailScalar(props) {
  var Component = Field;

  props.input = <input type="email" className="ofs-Input ofs-Input--text" />;
  props.component = <Component />;
  props.validate = emailValidator;
  return Scalar(props);
}



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/forms/scalars/EmailScalar.jsx
 **/